export const CheckIcon = () => {
  return (
    <svg width="33" height="25" viewBox="0 0 33 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 11L12 20.5L30 2.5" stroke="white" strokeWidth="6" />
    </svg>
  );
};

export const OpenIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <path
        d="M12.5 0C10.1266 0 7.80655 0.703788 5.83316 2.02236C3.85977 3.34094 2.3217 5.21508 1.41345 7.4078C0.505199 9.60051 0.267559 12.0133 0.730582 14.3411C1.1936 16.6689 2.33649 18.807 4.01472 20.4853C5.69295 22.1635 7.83115 23.3064 10.1589 23.7694C12.4867 24.2324 14.8995 23.9948 17.0922 23.0865C19.2849 22.1783 21.1591 20.6402 22.4776 18.6668C23.7962 16.6934 24.5 14.3734 24.5 12C24.4966 8.81843 23.2313 5.76814 20.9816 3.51843C18.7319 1.26872 15.6816 0.00335979 12.5 0ZM17.7685 14.4992C17.6827 14.5851 17.5809 14.6531 17.4689 14.6996C17.3568 14.746 17.2367 14.77 17.1154 14.77C16.9941 14.77 16.874 14.746 16.7619 14.6996C16.6498 14.6531 16.548 14.5851 16.4623 14.4992L12.5 10.5358L8.5377 14.4992C8.45193 14.585 8.35012 14.653 8.23806 14.6994C8.12601 14.7459 8.00591 14.7697 7.88462 14.7697C7.76333 14.7697 7.64323 14.7459 7.53118 14.6994C7.41912 14.653 7.31731 14.585 7.23154 14.4992C7.14578 14.4135 7.07775 14.3116 7.03133 14.1996C6.98492 14.0875 6.96103 13.9674 6.96103 13.8462C6.96103 13.7249 6.98492 13.6048 7.03133 13.4927C7.07775 13.3807 7.14578 13.2788 7.23154 13.1931L11.8469 8.57769C11.9327 8.49187 12.0345 8.42378 12.1465 8.37733C12.2586 8.33087 12.3787 8.30696 12.5 8.30696C12.6213 8.30696 12.7414 8.33087 12.8535 8.37733C12.9655 8.42378 13.0674 8.49187 13.1531 8.57769L17.7685 13.1931C17.8543 13.2788 17.9224 13.3806 17.9688 13.4927C18.0153 13.6047 18.0392 13.7248 18.0392 13.8462C18.0392 13.9675 18.0153 14.0876 17.9688 14.1996C17.9224 14.3117 17.8543 14.4135 17.7685 14.4992Z"
        fill="#20539F"
      />
    </svg>
  );
};

export const ArrowRightIcon = ({ className }) => {
  return (
    <svg
      className={className}
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path>
    </svg>
  );
};
